define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var CommissionModel = /** @class */ (function () {
        function CommissionModel(data) {
            this.Id = ko.observable(0);
            this.CommissionProvider = ko.observable(0);
            this.CommissionProviderName = ko.observable();
            this.EmployeeId = ko.observable(0);
            this.EmployeeName = ko.observable();
            this.EmployeeRoleId = ko.observable(0);
            this.EmployeeRoleName = ko.observable();
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.CustomerAccountNumber = ko.observable(0);
            this.CommissionRoleId = ko.observable(0);
            this.CommissionRoleName = ko.observable();
            this.InvoiceId = ko.observable(0);
            this.PaidDate = ko.observable();
            this.InvoiceNumber = ko.observable();
            this.ProductId = ko.observable(0);
            this.ProductName = ko.observable();
            this.ProductDescription = ko.observable();
            this.ProductType = ko.observable();
            this.ProductTypeName = ko.observable();
            this.ProductCategoryId = ko.observable(0);
            this.ProductCategoryName = ko.observable();
            this.ProductPrice = ko.observable(0);
            this.ProductQuantity = ko.observable(0);
            this.ProductTotal = ko.observable(0);
            this.Rate = ko.observable(0);
            this.CommissionTotal = ko.observable(0);
            this.IsFlat = ko.observable();
            this.ManualRate = ko.observable();
            this.IsApproved = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CommissionModel.Mapping, self);
            }
        }
        CommissionModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CommissionModel(options.data);
            },
            PaidDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return CommissionModel;
    }());
    return CommissionModel;
});
//# sourceMappingURL=CommissionModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CommissionModel.js
// module id = 306
// module chunks = 2